<template>
  <div class="upload-container">
    <div class="content-item">
      <div
        class="dummy-image"
        :style="
          selectedImage !== ''
            ? 'background-image: url(' + selectedImage + ')'
            : ''
        "
        @click="$refs.photo.click()"
      >
        <base-icon class-name="plus" :name="'plus-circle'" />
      </div>
    </div>
    <div class="upload-container">
      <div>
        <p><strong>Görsel Yükle</strong></p>
        <span>Görsel boyutu 350x350 px olmalıdır.</span>
      </div>
    </div>
    <input type="file" ref="photo" @change="setPhoto" />
  </div>
</template>

<script>
import { BaseIcon } from "@/components";
import { convertBase64 } from "@/utils/imageToBase64.js";

export default {
  name: "PhotoUpload",
  props: {
    base64Img: Function,
  },
  data() {
    return {
      selectedImage: "",
    };
  },
  components: {
    BaseIcon,
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setPhoto(e) {
      const file = e.target.files[0];
      this.selectedImage = URL.createObjectURL(file);
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$refs.photo.value = "";
        this.selectedImage = "";
        return this.$toast.error("Görsel jpeg yada png formatında olmalıdır.");
      }
      convertBase64(file).then((base64Img) => {
        const image = base64Img
          .replace("data:image/png;base64,", "")
          .replace("data:image/jpeg;base64,", "")
          .replace("data:image/jpg;base64,", "")
          .trim();
        this.$emit("setPhoto", image);
        this.base64Img(image);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container {
  padding: 10px 10px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  input {
    display: none;
  }
  .content-item {
    .dummy-image {
      width: 58px;
      height: 58px;
      border-radius: 3px;
      background-color: #f3f3f3;
      background-position: center center;
      background-size: cover;
      padding: 17px 17px;
      box-sizing: border-box;
      cursor: pointer;
      .plus {
        color: #b9b9b9;
      }
    }
  }
}
</style>
